import { Button } from "@mui/material";
import { IKeyDriveButton } from "../Fonts/Types/IKeyDriveButton";

export function KeyDrivePrimaryButton({
    startIcon,
    onClick,
    height,
    width,
    needFullWidth,
    disabled,
    TextComponent,
    TextComponentProps: {
        color,
        needBold,
        needEllipses,
        text
    },
    endIcon,
    backgroundColor,
    sx
}: IKeyDriveButton) {
    return (
        <Button
            variant="contained"
            startIcon={startIcon}
            endIcon={endIcon}
            onClick={onClick}
            sx={sx != undefined ? sx : {
                width: width,
                height: height,
                minWidth: "135px",
                background: backgroundColor == undefined ? "#22638D" : backgroundColor,
                color: "white",
                ":hover": {
                    background: "#D3E0E8",
                    color: "#22638D"
                },
                ":disabled": {
                    background: "#D5D5D5",
                    color: "#969696"
                }
            }}
            fullWidth={needFullWidth}
            disabled={disabled}
        >
            <TextComponent
                color={color}
                needBold={needBold}
                needEllipses={needEllipses}
                text={text}
            />
        </Button>
    )
}
